<template>
    <div class="row">
        <div class="col-9">
            <div v-if="title" class="c_head">{{title}}</div>
            <a v-else href="/"><button class="btn btn-primary">主页</button></a>
        </div>
        <div class="col-3 text-right">
            你好，<span v-if="user">{{user.realname}}</span>
            <button class="btn btn-danger ml-2" @click="logout()">退出</button>
        </div>
    </div>
</template>

<script>
    import User from "../services/user";
    import * as MsgBox from "../utils/msgBox";

    export default {
        name: "AppHeader",
        props: ["title"],
        computed: {
            user() {
                return User.user;
            },
        },
        methods: {
            async logout() {
                if (await MsgBox.confirm(this, "确认要退出？")) {
                    await User.logout();
                }
            },
        },
    }
</script>

<style scoped>
    .c_head {
        font-size: 1.5rem;
        font-weight: bold;
    }
</style>